import React from 'react';
import Icon, { IconSize } from './icon';
import { overrideClassName } from './index';

export enum SplatMode {
  PRIMARY = 'Primary',
  SUCCESS = 'Success',
  WARNING = 'Warning',
  DANGER = 'Danger'
}

let MainSplat = (props) => {
  let {
    children,
    mode = SplatMode.PRIMARY,
    icon,
    actions,
    closeAction,
    label = 'Alert Title',
    loading,
    className
  } = props;
  let modeStyles = {
    [SplatMode.PRIMARY]: `bg-primaryAlertBg-50`,
    [SplatMode.SUCCESS]: `bg-successAlertBg-50`,
    [SplatMode.WARNING]: `bg-warningAlertBg-50`,
    [SplatMode.DANGER]: `bg-dangerAlertBg-50`
  };
  let buttonHoverStyles = {
    [SplatMode.PRIMARY]: `hover:bg-primaryAlertHover-50`,
    [SplatMode.SUCCESS]: `hover:bg-successAlertHover-50`,
    [SplatMode.WARNING]: `hover:bg-warningAlertHover-50`,
    [SplatMode.DANGER]: `hover:bg-dangerAlertHover-50`
  };
  let textStyles = {
    [SplatMode.PRIMARY]: 'text-primaryAlertText-50',
    [SplatMode.SUCCESS]: 'text-successAlertText-50',
    [SplatMode.WARNING]: 'text-warningAlertText-50',
    [SplatMode.DANGER]: 'text-dangerAlertText-50'
  };
  let icons = {
    [SplatMode.PRIMARY]: 'information',
    [SplatMode.SUCCESS]: 'check-circle',
    [SplatMode.WARNING]: 'alert-circle',
    [SplatMode.DANGER]: 'alert-circle'
  };

  let iconClassName;
  if (loading) {
    icon = 'loading';
    iconClassName = 'animate-spin';
  }

  return (
    <div className={overrideClassName(` ${modeStyles[mode]} px-4 py-2`, className)} data-testid="splat-container">
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon
            mode={mode}
            size={IconSize.MD}
            icon={icon || icons[mode]}
            aria-hidden="true"
            className={iconClassName}
          />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${textStyles[mode]}`}>{label}</h3>
          {React.Children.toArray(children).length ? (
            <div className={`mt-2 text-sm ${textStyles[mode]}`}>{children}</div>
          ) : null}
          {actions && (
            <div className="mt-4">
              <div className="-mx-2 -my-1.5 flex">
                {actions.map((a, ai) => (
                  <button
                    key={ai}
                    type="button"
                    onClick={a.onClick}
                    className={`${modeStyles[mode]} px-2 py-1.5 rounded-md text-sm font-medium ${textStyles[mode]} ${buttonHoverStyles[mode]} focus:outline-none focus:ring-2 focus:ring-offset-2`}>
                    {a.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        {closeAction && (
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <Icon icon="close" aria-hidden={true} size={IconSize.MD} mode={mode} onClick={closeAction} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainSplat;
